import { useCallback, useState } from 'react';
import { questionLike } from '../../core/service/questionLike.service';
import CategoryLink from '../CategoryLink/CategoryLink';
import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import Heading from '../Heading/Heading';
import {
  StyledContainer,
  StyledCard,
  StyledHeading,
  StyledList,
  StyledListItem,
  StyledTitle,
  StyledIconButton,
} from './LikedQuestions.styles';

function LikedQuestions() {
  const [storage, setStorage] = useState(JSON.parse(localStorage.getItem('savedQuestions')));

  // TODO: Refactor whole component, with better code quality

  const onClick = useCallback(({ itemObject, question }) => {
    questionLike.update({
      experience: itemObject.name,
      category: itemObject.category,
      question,
    });
    setStorage(JSON.parse(localStorage.getItem('savedQuestions')));
  }, []);

  if (storage.length < 2) return null;

  return (
    <StyledContainer>
      <Wrapper>
        <Heading title="Liked Questions" icon={<Icon.Info2 />} />
      </Wrapper>
      {storage.map((item, index) => {
        if (!item.name || !item.questions[0]) return null;

        return (
          <StyledCard key={index}>
            <Wrapper>
              <StyledHeading>
                {item.name && <StyledTitle>{item.name}</StyledTitle>}
                {item.category && (
                  <CategoryLink
                    link={item.category.link}
                    color={item.category.color}
                    name={item.category.name}
                  />
                )}
              </StyledHeading>
              <StyledList>
                {item.questions &&
                  item.questions.map((element, key) => (
                    <StyledListItem key={key}>
                      {element}
                      <StyledIconButton
                        type="button"
                        onClick={() => onClick({ itemObject: item, question: element })}
                      >
                        <Icon.HeartBig />
                      </StyledIconButton>
                    </StyledListItem>
                  ))}
              </StyledList>
            </Wrapper>
          </StyledCard>
        );
      })}
    </StyledContainer>
  );
}

export default LikedQuestions;
